import { useState, ChangeEvent, KeyboardEvent, useRef, useCallback } from "react";
import { Link, Stack, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FormProvider, RHFOtpVerify } from "@app/components";
import { useForm } from "react-hook-form";
import { Strings } from "@app/constants";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { selectVerifyOTPState, verifyOtp } from "@app/modules/auth";
import { useRequestState } from "@app/hooks";
import { useNavigate } from "react-router-dom";


const OTPForm = ({setActiveStep,setGetCarValue}:any) => {
  const methods = useForm();
  const theme = useTheme();
  const dispatch = useDispatch();

  const isSmallScreen = useMediaQuery("(max-width:720px)");
  const textStyle = (size: number, weight = 400, color?: string) => ({
    fontFamily: "Work Sans",
    fontWeight: weight,
    fontSize: size,
    ...(color && { color }),
  });

  const handleNavigation = useCallback(()=>{
    setGetCarValue(true);
      setActiveStep(9);
  },[])

  useRequestState({
    stateSelector: selectVerifyOTPState,
    successMessageShown:true,
    onSuccess: handleNavigation
  })

  const onSubmit = (form:any) =>{
    dispatch(verifyOtp(form?.otp))
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      textAlign="center"
      spacing={isSmallScreen ? 2 : 4}
    >
      <FormProvider methods={methods}>
        <Stack spacing={2} sx={{ px: 6.8 }}>
          <Stack>
            <Stack spacing={2} sx={{ gap: 2 }} alignItems="center">
              <RHFOtpVerify name="otp" numInputs={4} />
            </Stack>
          </Stack>
        </Stack>

        <Stack alignItems="center">
          <LoadingButton
            onClick={methods.handleSubmit(onSubmit)}
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.main,
              borderRadius: "8px",
              width: isSmallScreen ? "100%" : "65%",
              py: 1.5,
              mt: 4,
            }}
          >
             {Strings.button.getMyCarsValue}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </Stack>
  );
};

export { OTPForm };
